export default {
    name: "WatchOurSeminars",
    created() {
        this.$nextTick(function () {
 
        });
    },
    mounted() {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {

    },
    methods: {

    }
};